export default {
  companyId: 1,
  setCompanyId(companyId) {
    this.companyId = companyId
  }
}
